module.exports = __webpack_public_path__ + "static/media/green-box1.d47b2964.jpg";